<!--
 * @Author: wiz/chengchangjun
 * @Description: 新版宇视播放器
-->
<template>
  <div ref="ysplayerRef" class="w-full h-full"></div>
</template>

<script>
import { IOTDeviceProtocolInstanceApi } from '@wiz-api/iot-device-management'

const iotDeviceProtocolInstanceApi = new IOTDeviceProtocolInstanceApi()
/* eslint-disable */
import axios from 'axios'

export default {
  props: {
    code: {
      type: String,
      defalut: '',
    },

    // 摄像头名称
    name: {
      type: String,
      default: '',
    },

    // 获取协议实例需要用到【pIid】,返回的内容包含有ip、端口、用户名、密码
    pIid: {
      type: String,
      defalut: '',
    },
  },

  created() {
    this.destroyInnerBox() // 先销毁 后创建

    const IsInit = window?.imosPlayer?.checkInit() || false
    console.log(
      '当前页面 是否已经初始化 | code | name ----->: ',
      window?.imosPlayer?.checkInit(),
      '|',
      this.code,
      '|',
      this.name
    )

    if (IsInit) {
      this.createWindow(this.code, this.name)
      return
    }

    this.getConfig() // 获取基础配置
  },

  beforeDestroy() {
    this.destroyInnerBox()
  },

  watch: {
    code(newCode) {
      console.log('当前的监控发生了值变更 code | name ----->: ', newCode, '|', this.name)

      if (this.iframeId && newCode) {
        this.startToggle(this.iframeId, newCode, this.name)
      }
    },
  },
  data() {
    return {
      UserName: '',
      PassWord: '',
      IP: '',
      Port: '',
      iframeId: '',
    }
  },

  methods: {
    keepalive(ystoken) {
      const _this = this
      axios({
        method: 'POST',
        url: `http://${_this.IP}:${_this.Port}/VIID/hadesadapter/user/keepalive`,
        headers: {
          'Content-Type': 'application/json; charset=utf8',
          Authorization: ystoken,
        },
        responseType: 'json',
      }).then((keepaliveRes) => {
        if (keepaliveRes.data.ErrCode === 404) {
          // VM B3351以前的用法
          const kaCLose = (e) => {
            console.warn('user dead', e)
          }
          let ws = new WebSocket(`ws://${_this.IP}:${_this.Port}/VIID/event`)
          ws.onopen = () => {
            ws.send(ystoken)
          }
          ws.onclose = kaCLose
          ws.onerror = kaCLose
        } else {
          // VM B3351以后的用法
          let reConnect = 0
          let time = setInterval(() => {
            axios({
              method: 'POST',
              url: `http://${_this.IP}:${_this.Port}/VIID/hadesadapter/user/keepalive`,
              headers: {
                'Content-Type': 'application/json; charset=utf8',
                Authorization: ystoken,
              },
              responseType: 'json',
            }).then((res2) => {
              if (res2.data.ErrCode !== 0) {
                reConnect++
                if (reConnect > 5) {
                  clearInterval(time)
                  reConnect = 0
                  console.warn('user dead')
                }
              } else {
                reConnect = 0
              }
            })
          }, 30000)
        }
      })
    },

    async login() {
      const _this = this

      if (!_this.IP || !_this.UserName || !_this.PassWord) {
        console.log('ip、用户名、密码不能为空')
        return
      }

      fetch(`http://${_this.IP}:${_this.Port}/VIID/login/v2`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json; charset=utf8',
        },
      })
        .then((firstLoginRes) => {
          if (firstLoginRes.status === 200) {
            return firstLoginRes.json()
          } else {
            throw new Error('第一次登录失败')
          }
        })
        .then((firstLoginRes1) => {
          const md5Create = forge.md.md5.create()
          const AccessCode = firstLoginRes1.AccessCode
          const Base64UserName = window.btoa(_this.UserName)
          const LoginSignatureTemp = Base64UserName + AccessCode + _this.PassWord

          md5Create.update(LoginSignatureTemp)
          const LoginSignature = md5Create.digest().toHex()

          fetch(`http://${_this.IP}:${_this.Port}/VIID/login/v2`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json; charset=utf8',
            },
            body: JSON.stringify({
              UserName: _this.UserName,
              AccessCode,
              LoginSignature,
            }),
          })
            .then((secondLoginRes) => {
              if (secondLoginRes.status === 200) {
                return secondLoginRes.json()
              } else {
                throw new Error('第二次登录失败')
              }
            })
            .then((secondLoginRes2) => {
              console.log('第二次登陆的返回结果 -----> :', secondLoginRes2)
              const ystoken = secondLoginRes2.AccessToken

              // 本接口必须在init之前调用
              _this.keepalive(ystoken)
              window.imosPlayer.setLinkPort(_this.LinkPort)

              // 本接口必须在init之前调用
              document.title = document.title + _this.getStr() + _this.getRandom()
              console.log('document.title -----> : ', document.title)

              window.imosPlayer
                .init({
                  ip: _this.IP, // 必传
                  token: ystoken, // 必传
                  title: document.title, // 必传
                  // offset: _this.offset,
                })
                .then(async (initRes) => {
                  if (initRes.ErrCode === 0) {
                    window.imosPlayer.cssScale(1)
                    window.imosPlayer.setLiveNetLinkMode('tcp', true)
                    window.imosPlayer.setReplayNetLinkMode('tcp', true)
                    _this.createWindow(_this.code, _this.name)
                  } else {
                    console.log('init的错误信息 -----> : ', initRes)
                  }
                })
                .catch((err) => {
                  console.error(err)
                })
            })
        })
    },

    async createWindow(code, name) {
      console.log('进入了创建窗格 code | name ----->: ', code, '|', name)

      const panelWindow = await window.imosPlayer.createPanelWindow()
      if (panelWindow === null) {
        console.log('创建窗格已达上限')
        return
      }
      // 窗格样式
      panelWindow.style.width = '100%'
      panelWindow.style.height = '100%'
      // window.imosPlayer.setVoidClassName(panelWindow, {
      //   className: 'new_yishi_window_pannel',
      // })
      window.imosPlayer.setVoidClassName(panelWindow, {
        className: 'ysplayer',
      })

      window.imosPlayer.setVoidBroadCastRegion({
        voidClassName: 'ysplayer',
        region: {
          times: 1000,
          class: ['el-message-box'], // 退出登录的弹框
        },
      })
      window.imosPlayer.setVideoProps(panelWindow.id, {
        needControls: true,
        needReplayControls: true,
        enableTitle: true,
        ptz: this.isHasPtz,
        liveMsgCallBack: (e) => {
          console.log('setVideoProps回调结果: ', e)
        },
      })
      this.iframeId = panelWindow.id // 把panelWindow窗格id存储下来 startToggle 使用
      const ysplayerBox = this.$refs.ysplayerRef
      ysplayerBox.appendChild(panelWindow)
      this.playLive(panelWindow.id, code, name)
    },

    playLive(iframeId, code, name = '') {
      window.imosPlayer.playLive(iframeId, {
        camera: code,
        title: name,
        stream: 1,
      })
    },

    // 无缝切换
    async startToggle(iframeId, code, name) {
      window.imosPlayer.startToggle(iframeId, {
        camera: code,
        title: name,
      })
    },

    // 销毁盒子
    destroyInnerBox() {
      this.$nextTick(() => {
        const ysplayerBox = this.$refs.ysplayerRef
        if (ysplayerBox && ysplayerBox.hasChildNodes()) {
          console.log('进入了销毁盒子 destroyInnerBox')
          ysplayerBox.innerHTML = null
        }
      })
    },

    async getConfig() {
      const _this = this
      const [err, res] = await iotDeviceProtocolInstanceApi.get(this.pIid)
      if (!err) {
        const jsonContent = JSON.parse(res.jsonContent)
        console.log('jsonContent', jsonContent)
        _this.UserName = jsonContent.UserName
        _this.PassWord = jsonContent.PassWord
        _this.IP = jsonContent.IP
        _this.Port = jsonContent.Port

        const scriptSrc = `http://${_this.IP}:${_this.LinkPort}/static/imosPlayer.min.js`
        console.log('scriptSrc', scriptSrc)

        await _this.loadScript(scriptSrc)
        await _this.login()
      }
    },

    // 子应用内动态加载脚本
    loadScript(url) {
      return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = url
        script.onload = resolve
        script.onerror = reject
        // Qiankun 沙箱环境下，将脚本插入子应用容器
        if (window.__POWERED_BY_QIANKUN__) {
          console.log('Qiankun 沙箱环境下，将脚本插入子应用容器')
          const subAppContainer = document.querySelector('#MicroiService')
          subAppContainer.appendChild(script)
        } else {
          document.head.appendChild(script)
        }
      })
    },

    // 生产唯一title工具类函数
    S4() {
      return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
    },
    getRandom() {
      return (
        this.S4() +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        '-' +
        this.S4() +
        this.S4() +
        this.S4()
      )
    },
    getStr(arrLength = 40) {
      let nbsp = String.fromCharCode(160)
      let arr = []
      arr.length = arrLength
      let str = arr.fill(nbsp).join('')
      return str
    },
  },

  computed: {
    LinkPort() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["wiz-iot-management"].config')
          ?.NewYSPlayerConfig?.LinkPort || '8093'
      )
    },
    // 是否云台控制权限
    isHasPtz() {
      return (
        _.get(Wiz, 'globalSettings.dynamicModules.modules["wiz-iot-management"].config')
          ?.NewYSPlayerConfig?.isControlPtz || false
      )
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .imosPlayer_title_btnDiv {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}

::v-deep .imosPlayer {
  box-sizing: border-box !important;
}
</style>
